import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "@mui/material";
import { useCashOutV2 } from "@/hooks/useCashOutV2";
import { CashOutDetailV2 } from "@/components/cashOut/CashOutDetailV2";
import { ErrorDisplay } from "@/components/common/ErrorDisplay";
import { LoadingSpinner } from "@/components/common/LoadingSpinner";

export function CashOutDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { getCashOut, approveCashOut } = useCashOutV2();

  // @ts-ignore - tRPC type issues
  const { data: cashOut, error, isLoading } = getCashOut({ id: id! });

  const handleBack = () => {
    navigate("/cash-outs");
  };

  const handleApprove = (cashOutId: string) => {
    // approveCashOut is already the .mutate method from tRPC
    approveCashOut({ id: cashOutId, approved: true });
    // Navigate back to list - the mutation handles success/error notifications
    navigate("/cash-outs");
  };

  if (error) {
    return (
      <Container maxWidth="lg">
        <ErrorDisplay error={error} />
      </Container>
    );
  }

  if (isLoading) {
    return (
      <Container maxWidth="lg">
        <LoadingSpinner />
      </Container>
    );
  }

  if (!cashOut) {
    return (
      <Container maxWidth="lg">
        <ErrorDisplay error={new Error("Cash out not found")} />
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <CashOutDetailV2
        cashOut={cashOut}
        onBack={handleBack}
        onApprove={handleApprove}
      />
    </Container>
  );
}
